<template>
  <FitHalfScreenDialogV2
    :class="[language.getLanguage(), 'ekyc-dialog-wrapper']"
    ref="ekycDialog"
    :isHideHeader="true"
    :isAppendToBody="true"
  >
    <div slot="bd" class="ekyc-dialog" v-stat.brow="'main.ekyc_dialog'">
      <div class="title">{{ optionsTitle }}</div>
      <div class="info-wrapper">
        <div
          class="info-item"
          v-for="(op, idx) in options"
          :key="idx"
          @click="onClick(op)"
          v-stat.brow.click="{ tag: 'main.ekyc_dialog_item', ext: { ftitle: op.title } }"
        >
          <div class="info-item-left">
            <img class="logo" :src="op.logo" />
          </div>
          <div class="info-item-right">
            <div class="info">
              <div class="info-title">
                <div>{{ op.title }}</div>
                <div v-if="op.isRecommend" class="info-recommend">{{ i18n('推薦') }}</div>
              </div>
              <div class="info-desc" v-html="op.desc"></div>
            </div>
            <FitIcon class="icon" namespace="wphk-ui" icon="arrow-right"></FitIcon>
          </div>
        </div>
      </div>
    </div>
    <div slot="ft" v-stat.click="'main.ekyc_dialog_close'" @click="onHideDialog">
      <div class="footer">{{ i18n('取消') }}</div>
    </div>
  </FitHalfScreenDialogV2>
</template>

<script setup lang="ts">
import { FitHalfScreenDialogV2, FitIcon } from '@tencent/wphk-ui';
import { i18n } from '@/i18n';
import { ref } from 'vue';
import { language } from '@tencent/ppd-base-libs';

// 暴露方法
defineExpose({ onShowDialog });

defineProps<{ options: any[]; optionsTitle: string }>();

// ekyc 弹窗
const ekycDialog = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

// 打开弹窗
function onShowDialog() {
  ekycDialog.value?.showDialog();
}

// 关闭弹窗
function onHideDialog() {
  ekycDialog.value?.hideDialog();
}

function onClick(info) {
  if (typeof info?.onClick === 'function') {
    info.onClick();
  }
}
</script>

<style lang="less">
@import (reference) '~@/less/main';
.ekyc-dialog-wrapper {
  .weui-half-screen-dialog {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.ekyc-dialog {
  .title {
    padding: 32 / @rem;
    .font-28-regular(rgba(0,0,0,0.9));
    .divider_bottom();
    margin-bottom: 10 / @rem;
  }
  .info-wrapper {
    padding: 0 / @rem 32 / @rem;
    .info-item {
      display: flex;
      align-items: flex-start;
      padding: 32 / @rem 32 / @rem 32 / @rem 0;
      .divider_bottom();
      .info-item-left {
        display: flex;
        align-items: flex-start;
        .logo {
          width: 56 / @rem;
          height: 56 / @rem;
          margin-right: 24 / @rem;
        }
      }
      .info-item-right {
        display: flex;
        align-items: center;
        flex: 1;
        .info {
          flex: 1;
          .info-title {
            .font-34-regular(rgba(0,0,0,0.9));
            display: flex;
            align-items: center;
            .info-recommend {
              background: #fa5151;
              border-radius: 50px;
              padding: 2 / @rem 16 / @rem;
              margin-left: 16 / @rem;
              .font-24-regular(#fff);
            }
          }
          .info-desc {
            .font-28-regular(rgba(0,0,0,0.5));
          }
        }
        .icon {
          width: 24 / @rem;
          font-size: 56 / @rem;
          color: rgba(0, 0, 0, 0.3);
        }
      }
      &:last-child::after {
        display: none;
      }
    }
  }
}
.footer {
  .font-34-regular(rgba(0,0,0,0.9));
  padding: 32 / @rem 0;
  text-align: center;
  border-top: 16 / @rem solid #f2f2f2;
}
</style>
